var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text",class:{ 'truncated': _vm.text.length > _vm.maxLength },on:{"mouseenter":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.text,_vm.show ? Infinity : _vm.maxLength))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }